import React from 'react'
import { useContext } from 'react';
import { useParams } from 'react-router-dom'
import { TabTitle } from '../../../../util/titleChanger'
import { GlobalState } from '../../../../GlobalState'
import { useState } from 'react';
import { useEffect } from 'react';
import { createCustomerAccount, updateCustomerAccount } from '../../../../action';
import { ToastContainer, toast } from 'react-toastify';

export default function CustomerAccForm() {
    const { cusId } = useParams();
    TabTitle(cusId > 0 ? "Update Customer" : "Create Customer");
    const state = useContext(GlobalState);
    const signInUser = JSON.parse(localStorage.getItem('user_data'));

    //Local States
    const [btnName, setBtnName] = useState("Save");
    const [focused, setFocused] = useState(false);
    const [values, setValues] = useState([]);

    //Local state
    const [customerAccountDetail] = state.cusAccountAPI.customerAccountDetail;
    const [customerId, setCustomerId] = state.cusAccountAPI.customerId;
    const [callback, setCallback] = state.cusAccountAPI.callback;

    //Customer State and auto complete
    const [allCustomers] = state.customerAPI.allCustomers;
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [selectCustomer, setSelectCustomer] = useState("")
    const suggestions = allCustomers.filter(customer =>
        customer.first_name.toString().toLowerCase().includes(selectCustomer.toString().toLowerCase())
    )

    const handleSuggestionClick = (suggestion) => {
        setSelectCustomer(suggestion.first_name + " " + suggestion.last_name)
        setShowSuggestions(false)
        setValues({
            ...values,
            customerId: suggestion.id
        })
    }

    const onChangeSelectCategory = (e) => {
        setSelectCustomer(e.target.value)
    }

    //Focus input elements
    const handleFocus = (e) => {
        setFocused(true)
    }

    //Get value form input elements and assign into values states
    const onChangeValue = (e) => {
        e.preventDefault();
        setValues({ ...values, [e.target.name]: e.target.value })
    }

    useEffect(() => {
        if (cusId > 0) {
            setBtnName('Update');
            setCustomerId(cusId);

            setValues({
                advance_amount: customerAccountDetail ? customerAccountDetail.advance_amount : "0",
                customerId: customerAccountDetail.customer ? customerAccountDetail.customer.id : "1"
            })

            allCustomers.map(customer => {
                const customerId = customerAccountDetail.customer ? customerAccountDetail.customer.id : 1;
                if (customerId === customer.id) {
                    setSelectCustomer(customer.first_name + " " + customer.last_name);
                }
            })
        }
    }, [cusId, customerId, customerAccountDetail, allCustomers])

    const submitForm = (e) => {
        e.preventDefault();
        const customerAccountInfo = {
            advance_amount: values.advance_amount,
            updatedBy: signInUser.id,
            customerId: values.customerId
        }

        if (cusId > 0) {
            updateCustomerAccount(cusId, customerAccountInfo, res => {
                if (res.status === 200) {
                    toast.success(res.data);
                    setCallback(!callback);
                } else {
                    toast.error(res.data);
                    setCallback(!callback);
                }
            })
        } else {
            customerAccountInfo.createdBy = signInUser.id
            createCustomerAccount(customerAccountInfo, res => {
                if (res.status === 200) {
                    toast.success(res.data);
                    setCallback(!callback);
                } else {
                    toast.error(res.data);
                    setCallback(!callback);
                }
            })
        }
    }

    return (
        <div className="form-container">
            <header>Customer Accounts Form</header>
            <form onSubmit={submitForm} className="form">
                <div className="input-box">
                    <label htmlFor="customerId">Customer Name</label>
                    <input
                        type="text"
                        name="customerId"
                        id="customerId"
                        placeholder='Enter Customer Name'
                        value={selectCustomer}
                        required onBlur={handleFocus}
                        focused={focused.toString()}
                        onChange={onChangeSelectCategory}
                        onFocus={() => setShowSuggestions(true)}
                    />
                    {
                        showSuggestions && (
                            <ul className='suggestions'>
                                {suggestions.map(suggestion => (
                                    <li key={suggestion.id} onClick={() => handleSuggestionClick(suggestion)}>{suggestion.first_name + " " + suggestion.last_name}</li>
                                ))}
                            </ul>
                        )
                    }
                </div>

                <div className="input-box">
                    <label htmlFor="advance_amount">Advance Amount</label>
                    <input
                        type="text"
                        name="advance_amount"
                        id="advance_amount"
                        placeholder='Enter Advanced Amount'
                        value={values.advance_amount || ""}
                        required pattern='^(?:[1-9]|\d\d\d*)$'
                        onBlur={handleFocus}
                        focused={focused.toString()}
                        onChange={onChangeValue}
                    />
                    <span>Advanced amount should be number and more than 1.</span>
                </div>
                <div className="form-button">
                    <button className="add_new">{btnName}</button>
                </div>
            </form>
            <ToastContainer />
        </div>
    )
}
